export { isArray }

/**
 * Checks if the given value is an object.
 *
 * @param {any} value
 * @returns {true | false} true if `value` is an object; otherwise false
 */
function isArray(value) {
  return Array.isArray(value)
}
